import { Modal } from "@mui/material";
import { useEffect, useState } from "react";
import "./styles.css";
import RefundTable from "./RefundTable";
import DSBankDetails from "./DSBankDetails";
import Cookies from "js-cookie";
import { postData } from "../../Hooks/apiCalls";
import { toast } from "react-toastify";
import Loader from "../../CommonComponents/Loader";
import SearchableSelect from "./SearchableSelect";
import { isDevelopment } from "../../Hooks/constants";

const DSRefundRequest = ({
  open,
  handleClose,
  getAllRefundDetailsApi = () => {},
}) => {
  // variables
  const domain_id = Cookies.get("ssp_domain_id");
  const ssp_role = Cookies.get("ssp_role");
  const ssp_loc = Cookies.get("ssp_loc");

  const [storeLocations, setStoreLocations] = useState([]);
  const [selectedStore, setSelectedStore] = useState([]);
  const [billData, setBillData] = useState([]);
  const [billNo, setBillNo] = useState("");
  const [loader, setLoader] = useState(false);
  const [getLocationsLoader, setGetLocationsLoader] = useState(false);
  const [billDetailsLoader, setBillDetailsLoader] = useState(false);
  const [submitingBankDetailsLoader, setSubmitingBankDetailsLoader] =
    useState(false);

  const [beneficiaryName, setBenificiaryName] = useState("");
  const [bankNumber, setBankNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [branchName, setBranchName] = useState("");
  const [bankName, setBankName] = useState("");
  const [items, setItems] = useState([]);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  // function
  const totalRefundAmount = items
    .reduce((sum, item) => sum + (item.refund_amount || 0), 0)
    .toFixed(2);

  const handleChangeBenifiName = (e) => {
    setBenificiaryName(e.target.value);
  };
  const handleChangeBankNumber = (e) => {
    const value = e.target.value;
    const regex = /^\d+$/; // Regular expression for numbers
    if (value === "" || regex.test(value)) {
      setBankNumber(value);
    }
  };
  const handleChangeIFSCCode = (e) => {
    setIfscCode(e.target.value);
  };
  const handleChangeBranchName = (e) => {
    setBranchName(e.target.value);
  };
  const handleChangeBankName = (e) => {
    setBankName(e.target.value);
  };
  const handleSetBillNumber = (e) => {
    const value = e.target.value;
    const regex = /^\d*$/;
    if (regex.test(value)) {
      setBillNo(value);
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadFileLoader(true);
      const payload = {
        file_name: file?.name,
        domain_id: domain_id,
      };

      try {
        const { data } = await postData(
          `${
            isDevelopment
              ? process.env.REACT_APP_DSREFUND_DEV
              : process.env.REACT_APP_DSREFUND_PROD
          }get_post_url`,
          true,
          false,
          payload
        );
        const response = data?.body;

        if (response.status === "success") {
          setUploadedFileName(response.aws_key);
          const fileUploadData = new FormData();
          const fields = response?.data?.fields;
          Object.keys(fields).forEach((key) => {
            fileUploadData.append(key, fields[key]);
          });
          fileUploadData.append("file", file);
          const responseUpload = await postData(
            response?.data?.url,
            true, //isAuth
            true, //fileDownload
            fileUploadData,
            true //fileUpload
          );
          // console.log(responseUpload);
          setUploadFileLoader(false);
        } else {
          setUploadFileLoader(false);
        }
      } catch (err) {
        setUploadFileLoader(false);
        console.log(err);
      }
    }
  };
  // Api calls
  const getAllStoresApi = async () => {
    const payload = {
      domain_id: domain_id,
      role: ssp_role === "21" ? "store" : ssp_role === "18" && "finance",
    };
    setGetLocationsLoader(true);
    try {
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }get_all_stores`,
        true,
        false,
        payload
      );
      const response = data?.body;

      if (response?.status === "success") {
        setStoreLocations(response?.data);
        setGetLocationsLoader(false);
      } else {
        setGetLocationsLoader(false);
        toast.error(response?.message, { autoClose: 1500 });
      }
    } catch (err) {
      setGetLocationsLoader(false);
      console.log(err);
    }
  };

  const getBillDetailsApi = async () => {
    const payload = {
      domain_id: domain_id,
      role: ssp_role === "18" ? "finance" : "store",
      store_code:
        ssp_role === "18" ? Number(selectedStore.loc) : Number(ssp_loc),
      bill_no: billNo,
    };
    setBillDetailsLoader(true);
    try {
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }get_bill_details`,
        true,
        false,
        payload
      );
      const response = data?.body;

      if (response?.status === "success") {
        setBillData(response?.data);
        setBillDetailsLoader(false);
      } else {
        setBillDetailsLoader(false);
        toast.error(response?.message, { autoClose: 1500 });
      }
    } catch (err) {
      setBillDetailsLoader(false);
      console.log(err);
    }
  };
  const submitBankDetails = async () => {
    const filteredItems = items
      .map((item) => ({
        ...item,
        refund_qty: Number(item.refund_qty), // ensure numeric
      }))
      .filter((item) => !(item.refund_amount === 0 && item.refund_qty === 0));

    // console.log(filteredItems);
    const payload = {
      store_code: ssp_role === "18" ? selectedStore?.loc : Number(ssp_loc),
      bill_no: billNo,
      item_details: filteredItems,
      total_amount: Number(totalRefundAmount) ?? 0,
      bank_account_number: bankNumber,
      bank_ifsc_code: ifscCode,
      beneficiary_name: beneficiaryName,
      bank_name: bankName,
      branch_name: branchName,
      domain_id: domain_id,
      file_name: uploadedFileName ?? "",
    };
    setSubmitingBankDetailsLoader(true);
    try {
      const { data } = await postData(
        `${
          isDevelopment
            ? process.env.REACT_APP_DSREFUND_DEV
            : process.env.REACT_APP_DSREFUND_PROD
        }submit_refund`,
        true,
        false,
        payload
      );
      const response = data?.body;

      if (response?.status === "success") {
        toast.success(response?.message, { autoClose: 1500 });
        getAllRefundDetailsApi();
        setSubmitingBankDetailsLoader(false);
        handleModalClose();
      } else {
        toast.error(response?.message);
        setSubmitingBankDetailsLoader(false);
        if (
          response?.message ===
          "Refund request already exists against the bill no."
        ) {
          handleModalClose();
        }
      }
    } catch (err) {
      setSubmitingBankDetailsLoader(false);
      handleClose();
    }
  };

  const handleModalClose = () => {
    setBillData([]);
    setItems([]);
    setBenificiaryName("");
    setBankNumber("");
    setIfscCode("");
    setBranchName("");
    setBankName("");
    setBillNo("");
    setUploadedFileName("");
    handleClose();
  };
  useEffect(() => {
    if (open && ssp_role === "18") getAllStoresApi();
  }, [open, ssp_role]);

  // useEffect(() => {
  //   if (billNo.length >= 18) getBillDetailsApi();
  // }, [billNo]);
  return (
    <>
      <Modal open={open} className="flex justify-center items-center">
        <div className="dsRequestContainer bg-white w-[80%] max-h-[90vh] rounded-lg flex flex-col overflow-hidden">
          {/* Header  */}
          <div className="dsRequestHeader sticky top-0 bg-white px-4 py-3 z-10 border-b flex justify-between text-[#172128]">
            <span>{ssp_role === "18" ? "Bill Details" : "Create Request"}</span>
            <button className="dsRequestCloseBtn" onClick={handleModalClose}>
              Close
            </button>
          </div>

          {/* Content  */}

          <div className="dsRequestContent">
            <div className="dsRequestInputs">
              {/* location search  */}

              <div className="relative dsRequestInpLablel">
                <label
                  htmlFor="inputField1"
                  className="block text-sm font-semibold text-gray-700">
                  Store <sup className="required">*</sup> :{" "}
                  {ssp_role !== "18" && ssp_loc}
                </label>

                <SearchableSelect
                  options={storeLocations}
                  placeholder="Search by location code or name"
                  onChange={(selected) => setSelectedStore(selected)}
                />
              </div>
              <div className="dsRequestInpLablel">
                <label
                  className="block text-sm font-semibold text-gray-700"
                  htmlFor="inputField2">
                  Bill No. <sup className="required">*</sup> :
                </label>
                <>
                  <input
                    value={billNo}
                    type="text"
                    id="inputField2"
                    name="inputField2"
                    onChange={handleSetBillNumber}
                    onKeyDown={(e) => {
                      if ((e.key === "Enter") & (billNo.length >= 10)) {
                        getBillDetailsApi();
                      }
                    }}
                  />
                  <span className="dsInfoMessage ">
                    ( Press Enter to Search )
                  </span>
                </>
              </div>
            </div>
            <br />
            <div className="line"></div>
            <br />
            <RefundTable
              billData={billData}
              items={items}
              setItems={setItems}
              totalRefundAmount={totalRefundAmount}
            />
            <br />
            {ssp_role !== "18" && (
              <DSBankDetails
                submitBankDetails={submitBankDetails}
                handleChangeBankNumber={handleChangeBankNumber}
                handleChangeBranchName={handleChangeBranchName}
                handleChangeIFSCCode={handleChangeIFSCCode}
                handleChangeBenifiName={handleChangeBenifiName}
                handleChangeBankName={handleChangeBankName}
                bankName={bankName}
                ifscCode={ifscCode}
                branchName={branchName}
                bankNumber={bankNumber}
                benificiaryName={beneficiaryName}
                totalRefundAmount={totalRefundAmount}
                handleFileUpload={handleFileUpload}
              />
            )}
          </div>
        </div>
      </Modal>
      <Loader
        loading={
          getLocationsLoader ||
          billDetailsLoader ||
          submitingBankDetailsLoader ||
          uploadFileLoader
        }
        text={
          getLocationsLoader
            ? "Getting Store locations. Please Wait !!!"
            : billDetailsLoader
            ? "Fetching entered Bill Details"
            : submitingBankDetailsLoader
            ? "Submiting Bank details with the Total Refund Amount"
            : uploadFileLoader
            ? "Uploading Image , Please Wait !!!"
            : ""
        }
      />
    </>
  );
};

export default DSRefundRequest;
